import { styled } from "@mui/material/styles";
import { Button, Grid, Typography } from "@mui/material";

export const MainContainer = styled(Grid)({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-end",
  width: "700px",
  margin: "15px 0",
});

export const Container = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  width: "700px",
});

export const RowContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  width: "700px",
  margin: "5px 0",
});

export const CellBlock = styled(Grid)({
  width: "150px",
});

export const AmountBlock = styled(Grid)({
  width: "130px",
  display: "flex",
  justifyContent: "flex-end",
});

export const ActionsBlock = styled(Grid)({
  width: "100px",
});

export const HeaderName = styled(Typography)({
  fontWeight: "bold",
});

export const CellSimpleText = styled(Typography)({
  width: "130px",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const AmountContainer = styled(Grid)({
  display: "flex",
  flexDirection: "row",
  width: "130px",
  flexWrap: "wrap",
  justifyContent: "flex-end",
  alignItems: "center",
});

export const AmountSpan = styled(Typography)({
  maxWidth: "130px",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const AmountCurrency = styled(Typography)({
  marginLeft: "5px",
});

export const AddRowContainer = styled(Grid)({
  margin: "5px 0",
});
